import "@/App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';
import Login from "@/components/Login";
import KasirDashboard from "@/components/KasirDashboard";
import AdminDashboard from "@/components/AdminDashboard";
import SmartThingsOAuth from "@/components/SmartThingsOAuth";
import StockOpnamePage from "@/components/StockOpnamePage";
import StockOpnameDetail from "@/components/StockOpnameDetail";
import StockOpnameCountingForm from "@/components/StockOpnameCountingForm";
import ProfilePage from "@/components/ProfilePage";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="billing-app">
      <Toaster position="top-right" richColors />
      <Router>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route 
          path="/kasir" 
          element={
            <ProtectedRoute allowedRoles={['kasir', 'admin', 'supervisor']}>
              <KasirDashboard />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/settings" 
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <SmartThingsOAuth />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/stock-opname" 
          element={
            <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
              <StockOpnamePage />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/stock-opname/:opnameId" 
          element={
            <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
              <StockOpnameDetail />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/stock-opname/:opnameId/form" 
          element={
            <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
              <StockOpnameCountingForm />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/profile" 
          element={
            <ProtectedRoute allowedRoles={['admin', 'supervisor', 'kasir']}>
              <ProfilePage />
            </ProtectedRoute>
          } 
        />
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;
